import { C1AutocompleteSingleAsyncHook } from 'components/core/autocomplete/C1AutocompleteSingleAsync'
import { renderLabel } from 'components/core/search'
import { AppRenderOption } from 'components/core/search/apps'
import { AccessRequest } from 'components/pages/accessrequest/create/form-v2/RequestAccessFormV2'
import { App } from 'pbts/c1/api/app/v1/app'
import { RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest } from 'pbts/c1/api/requestcatalog/v1/requestcatalog'
import { FC } from 'react'
import { Control, Controller, useController } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { searchAppsWithGrantStatusApi } from 'redux_toolkit/request-catalogs'

type AccessRequestFormUserFieldProps = {
    control: Control<AccessRequest>
    autoFocus?: boolean
}

type ReqType = RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest
export const AccessRequestFormAppField: FC<AccessRequestFormUserFieldProps> = ({
    control,
    autoFocus,
}) => {
    const intl = useIntl()
    const { field: user } = useController({
        name: 'user',
        control,
    })

    const req = {
        create: (args: Partial<ReqType>) => RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest.create({
            targetUserId: user.value?.id,
            ...args,
        }),
    }

    return <Controller
        name="app"
        control={control}
        render={({ field }): React.ReactElement => <div data-testid="access-request-app-select">
            <C1AutocompleteSingleAsyncHook<ReqType, App>
                fullWidth
                id="app"
                placeholder={intl.formatMessage({
                    id: 'SelectOneAppHook_placeholder',
                    defaultMessage: 'Select an app',
                })}
                type={App}
                hook={searchAppsWithGrantStatusApi.useLazySearchAppsWithGrantStatus}
                Req={req}
                renderOption={AppRenderOption}
                renderLabel={renderLabel}
                onSelected={(v: App | null): void => field.onChange(v)}
                onBlur={field.onBlur}
                value={(field.value || null) as unknown as App}
                disabled={!user.value?.id}
                autoFocus={autoFocus}
            />
        </div>
        }
    />
}
